import monitorIcon from "./MonitorIcon.png";

export const MonitorsIcon = () => <img src={monitorIcon} alt="monitor" />;
